import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "input-container" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-default p-0 w-full",
  role: "alert"
}

import AddressInputComponent from "@/builder/components/textInput/AddressInputComponent.vue";
import CommentsInputComponent from "@/builder/components/textInput/CommentsInputComponent.vue";
import EmailInputComponent from "@/builder/components/textInput/EmailInputComponent.vue";
import NameInputComponent from "@/builder/components/textInput/NameInputComponent.vue";
import PhoneNumberInputComponent from "@/builder/components/textInput/PhoneNumberInputComponent.vue";
import { ITextInputComponent, InputType } from "@/builder/components/textInput/TextInputInterface";
import { PropType } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TextInputComponent',
  props: {
    component: {
        type: Object as PropType<ITextInputComponent>,
        required: true
    }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (isNaN(__props.component.customData.type))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "items-center flex max-w-[90%]" }, [
            _createElementVNode("i", {
              class: "ri-loader-line mr-2.5",
              "aria-hidden": "true"
            }),
            _createElementVNode("p", { class: "!text-sm font-medium" }, "No text input type has been selected. Pick one from the editor panel to get started!")
          ], -1)
        ])))
      : _createCommentVNode("", true),
    (__props.component.customData.type === _unref(InputType).Name)
      ? (_openBlock(), _createBlock(NameInputComponent, {
          key: 1,
          component: __props.component
        }, null, 8, ["component"]))
      : _createCommentVNode("", true),
    (__props.component.customData.type === _unref(InputType).Email)
      ? (_openBlock(), _createBlock(EmailInputComponent, {
          key: 2,
          component: __props.component
        }, null, 8, ["component"]))
      : _createCommentVNode("", true),
    (__props.component.customData.type === _unref(InputType).PhoneNumber)
      ? (_openBlock(), _createBlock(PhoneNumberInputComponent, {
          key: 3,
          component: __props.component
        }, null, 8, ["component"]))
      : _createCommentVNode("", true),
    (__props.component.customData.type === _unref(InputType).Comments)
      ? (_openBlock(), _createBlock(CommentsInputComponent, {
          key: 4,
          component: __props.component
        }, null, 8, ["component"]))
      : _createCommentVNode("", true),
    (__props.component.customData.type === _unref(InputType).Address)
      ? (_openBlock(), _createBlock(AddressInputComponent, {
          key: 5,
          component: __props.component
        }, null, 8, ["component"]))
      : _createCommentVNode("", true)
  ]))
}
}

})